import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from 'redux'
import {change} from 'redux-form'
import ContactSummaryForm from "./form/contactSummaryForm";

class CFTaskContacts extends Component {

  constructor(props) {
    super(props);
    this.state = {
      contact: null,
      contactId: null,
    }

  }

  getUserName = (user) => `${user.FirstName} ${user.LastName}`

  renderContactTable = (items) => {
    return (<section className={`list-view-table`}>
        <div className="table-wrapper">
          <table className="table">
            <thead>
            <tr>
              <th><span className="col-th-wrapper">Contact Type</span></th>
              <th><span className="col-th-wrapper">Name</span></th>
              <th><span className="col-th-wrapper">Email</span></th>
              <th><span className="col-th-wrapper">Phone</span></th>
              <th><span className="col-th-wrapper">Mobile</span></th>
            </tr>
            </thead>
            <tbody>
            {items.map((elem) => {
              return (
                <tr key={this.getUserName(elem)} onClick={() => this.setContactPerson(elem)}>
                  <td>{elem.contactType}</td>
                  <td>{this.getUserName(elem)}</td>
                  <td><a target={'_blank'} href={'mail'}>{elem.emailAddress}</a></td>
                  <td>{elem.phoneNumber}</td>
                  <td>{elem.mobileNumber}</td>
                </tr>
              )
            })}
            </tbody>
          </table>
        </div>
      </section>
    );
  }


  setContactPerson = (user) => {
    this.setState({
      contact: this.getUserName(user),
      contactUser: this.getUserName(user)
    });
    this.props.enableForm(this.getUserName(user));

  }

  render() {
    const { contactList, handleTaskSubmit, userCanCloseTask } = this.props;

    return (
      <React.Fragment>
        {(contactList.length > 0) ?
          <React.Fragment>
            <div className="row">
              <div className="col-12">
                {this.renderContactTable(contactList)}
              </div>
            </div>
          </React.Fragment>
          : null
        }
        <ContactSummaryForm
          items={contactList}
          onSubmit={handleTaskSubmit}
          dismiss={this.props.onHide}
          contact={this.state.contact}
          closeAndNew={this.props.closeAndNew}
          userCanCloseTask={userCanCloseTask}
        />
      </React.Fragment>
    );
  }
};

CFTaskContacts.propTypes = {};

const mapStateToProps = (state) => {
  return {
    locale: state.localization.strings.CFTasks.viewDetail.contacts,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    enableForm: (name) => change('taskContactSummaryForm', 'contactUser', name)
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CFTaskContacts);